/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as ErrorImport } from './routes/error'
import { Route as AccountSlugRouteImport } from './routes/$accountSlug/route'
import { Route as IndexImport } from './routes/index'
import { Route as AccountSlugIndexImport } from './routes/$accountSlug/index'
import { Route as AccountSlugSubmissionIdIndexImport } from './routes/$accountSlug/$submissionId/index'
import { Route as AccountSlugSubmissionIdSignerImport } from './routes/$accountSlug/$submissionId/signer'
import { Route as TradeReferencesAccountSlugTrackingIdIndexImport } from './routes/trade-references/$accountSlug/$trackingId/index'
import { Route as PersonalGuarantorsAccountSlugTrackingIdIndexImport } from './routes/personal-guarantors/$accountSlug/$trackingId/index'
import { Route as AccountSlugSubmissionIdTokenIndexImport } from './routes/$accountSlug/$submissionId/$token/index'
import { Route as AccountSlugSubmissionIdSignerTokenTokenImport } from './routes/$accountSlug/$submissionId/signer-token/$token'
import { Route as AccountSlugSubmissionIdAdditionalTradeReferencesTokenTokenImport } from './routes/$accountSlug/$submissionId/additional-trade-references-token/$token'
import { Route as AccountSlugSubmissionIdAdditionalThirdPartiesTypeImport } from './routes/$accountSlug/$submissionId/additional-third-parties/$type'
import { Route as AccountSlugSubmissionIdAdditionalPersonalGuarantorsTokenTokenImport } from './routes/$accountSlug/$submissionId/additional-personal-guarantors-token/$token'

// Create/Update Routes

const ErrorRoute = ErrorImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => rootRoute,
} as any)

const AccountSlugRouteRoute = AccountSlugRouteImport.update({
  id: '/$accountSlug',
  path: '/$accountSlug',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const AccountSlugIndexRoute = AccountSlugIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AccountSlugRouteRoute,
} as any)

const AccountSlugSubmissionIdIndexRoute =
  AccountSlugSubmissionIdIndexImport.update({
    id: '/$submissionId/',
    path: '/$submissionId/',
    getParentRoute: () => AccountSlugRouteRoute,
  } as any)

const AccountSlugSubmissionIdSignerRoute =
  AccountSlugSubmissionIdSignerImport.update({
    id: '/$submissionId/signer',
    path: '/$submissionId/signer',
    getParentRoute: () => AccountSlugRouteRoute,
  } as any)

const TradeReferencesAccountSlugTrackingIdIndexRoute =
  TradeReferencesAccountSlugTrackingIdIndexImport.update({
    id: '/trade-references/$accountSlug/$trackingId/',
    path: '/trade-references/$accountSlug/$trackingId/',
    getParentRoute: () => rootRoute,
  } as any)

const PersonalGuarantorsAccountSlugTrackingIdIndexRoute =
  PersonalGuarantorsAccountSlugTrackingIdIndexImport.update({
    id: '/personal-guarantors/$accountSlug/$trackingId/',
    path: '/personal-guarantors/$accountSlug/$trackingId/',
    getParentRoute: () => rootRoute,
  } as any)

const AccountSlugSubmissionIdTokenIndexRoute =
  AccountSlugSubmissionIdTokenIndexImport.update({
    id: '/$submissionId/$token/',
    path: '/$submissionId/$token/',
    getParentRoute: () => AccountSlugRouteRoute,
  } as any)

const AccountSlugSubmissionIdSignerTokenTokenRoute =
  AccountSlugSubmissionIdSignerTokenTokenImport.update({
    id: '/$submissionId/signer-token/$token',
    path: '/$submissionId/signer-token/$token',
    getParentRoute: () => AccountSlugRouteRoute,
  } as any)

const AccountSlugSubmissionIdAdditionalTradeReferencesTokenTokenRoute =
  AccountSlugSubmissionIdAdditionalTradeReferencesTokenTokenImport.update({
    id: '/$submissionId/additional-trade-references-token/$token',
    path: '/$submissionId/additional-trade-references-token/$token',
    getParentRoute: () => AccountSlugRouteRoute,
  } as any)

const AccountSlugSubmissionIdAdditionalThirdPartiesTypeRoute =
  AccountSlugSubmissionIdAdditionalThirdPartiesTypeImport.update({
    id: '/$submissionId/additional-third-parties/$type',
    path: '/$submissionId/additional-third-parties/$type',
    getParentRoute: () => AccountSlugRouteRoute,
  } as any)

const AccountSlugSubmissionIdAdditionalPersonalGuarantorsTokenTokenRoute =
  AccountSlugSubmissionIdAdditionalPersonalGuarantorsTokenTokenImport.update({
    id: '/$submissionId/additional-personal-guarantors-token/$token',
    path: '/$submissionId/additional-personal-guarantors-token/$token',
    getParentRoute: () => AccountSlugRouteRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/$accountSlug': {
      id: '/$accountSlug'
      path: '/$accountSlug'
      fullPath: '/$accountSlug'
      preLoaderRoute: typeof AccountSlugRouteImport
      parentRoute: typeof rootRoute
    }
    '/error': {
      id: '/error'
      path: '/error'
      fullPath: '/error'
      preLoaderRoute: typeof ErrorImport
      parentRoute: typeof rootRoute
    }
    '/$accountSlug/': {
      id: '/$accountSlug/'
      path: '/'
      fullPath: '/$accountSlug/'
      preLoaderRoute: typeof AccountSlugIndexImport
      parentRoute: typeof AccountSlugRouteImport
    }
    '/$accountSlug/$submissionId/signer': {
      id: '/$accountSlug/$submissionId/signer'
      path: '/$submissionId/signer'
      fullPath: '/$accountSlug/$submissionId/signer'
      preLoaderRoute: typeof AccountSlugSubmissionIdSignerImport
      parentRoute: typeof AccountSlugRouteImport
    }
    '/$accountSlug/$submissionId/': {
      id: '/$accountSlug/$submissionId/'
      path: '/$submissionId'
      fullPath: '/$accountSlug/$submissionId'
      preLoaderRoute: typeof AccountSlugSubmissionIdIndexImport
      parentRoute: typeof AccountSlugRouteImport
    }
    '/$accountSlug/$submissionId/additional-personal-guarantors-token/$token': {
      id: '/$accountSlug/$submissionId/additional-personal-guarantors-token/$token'
      path: '/$submissionId/additional-personal-guarantors-token/$token'
      fullPath: '/$accountSlug/$submissionId/additional-personal-guarantors-token/$token'
      preLoaderRoute: typeof AccountSlugSubmissionIdAdditionalPersonalGuarantorsTokenTokenImport
      parentRoute: typeof AccountSlugRouteImport
    }
    '/$accountSlug/$submissionId/additional-third-parties/$type': {
      id: '/$accountSlug/$submissionId/additional-third-parties/$type'
      path: '/$submissionId/additional-third-parties/$type'
      fullPath: '/$accountSlug/$submissionId/additional-third-parties/$type'
      preLoaderRoute: typeof AccountSlugSubmissionIdAdditionalThirdPartiesTypeImport
      parentRoute: typeof AccountSlugRouteImport
    }
    '/$accountSlug/$submissionId/additional-trade-references-token/$token': {
      id: '/$accountSlug/$submissionId/additional-trade-references-token/$token'
      path: '/$submissionId/additional-trade-references-token/$token'
      fullPath: '/$accountSlug/$submissionId/additional-trade-references-token/$token'
      preLoaderRoute: typeof AccountSlugSubmissionIdAdditionalTradeReferencesTokenTokenImport
      parentRoute: typeof AccountSlugRouteImport
    }
    '/$accountSlug/$submissionId/signer-token/$token': {
      id: '/$accountSlug/$submissionId/signer-token/$token'
      path: '/$submissionId/signer-token/$token'
      fullPath: '/$accountSlug/$submissionId/signer-token/$token'
      preLoaderRoute: typeof AccountSlugSubmissionIdSignerTokenTokenImport
      parentRoute: typeof AccountSlugRouteImport
    }
    '/$accountSlug/$submissionId/$token/': {
      id: '/$accountSlug/$submissionId/$token/'
      path: '/$submissionId/$token'
      fullPath: '/$accountSlug/$submissionId/$token'
      preLoaderRoute: typeof AccountSlugSubmissionIdTokenIndexImport
      parentRoute: typeof AccountSlugRouteImport
    }
    '/personal-guarantors/$accountSlug/$trackingId/': {
      id: '/personal-guarantors/$accountSlug/$trackingId/'
      path: '/personal-guarantors/$accountSlug/$trackingId'
      fullPath: '/personal-guarantors/$accountSlug/$trackingId'
      preLoaderRoute: typeof PersonalGuarantorsAccountSlugTrackingIdIndexImport
      parentRoute: typeof rootRoute
    }
    '/trade-references/$accountSlug/$trackingId/': {
      id: '/trade-references/$accountSlug/$trackingId/'
      path: '/trade-references/$accountSlug/$trackingId'
      fullPath: '/trade-references/$accountSlug/$trackingId'
      preLoaderRoute: typeof TradeReferencesAccountSlugTrackingIdIndexImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

interface AccountSlugRouteRouteChildren {
  AccountSlugIndexRoute: typeof AccountSlugIndexRoute
  AccountSlugSubmissionIdSignerRoute: typeof AccountSlugSubmissionIdSignerRoute
  AccountSlugSubmissionIdIndexRoute: typeof AccountSlugSubmissionIdIndexRoute
  AccountSlugSubmissionIdAdditionalPersonalGuarantorsTokenTokenRoute: typeof AccountSlugSubmissionIdAdditionalPersonalGuarantorsTokenTokenRoute
  AccountSlugSubmissionIdAdditionalThirdPartiesTypeRoute: typeof AccountSlugSubmissionIdAdditionalThirdPartiesTypeRoute
  AccountSlugSubmissionIdAdditionalTradeReferencesTokenTokenRoute: typeof AccountSlugSubmissionIdAdditionalTradeReferencesTokenTokenRoute
  AccountSlugSubmissionIdSignerTokenTokenRoute: typeof AccountSlugSubmissionIdSignerTokenTokenRoute
  AccountSlugSubmissionIdTokenIndexRoute: typeof AccountSlugSubmissionIdTokenIndexRoute
}

const AccountSlugRouteRouteChildren: AccountSlugRouteRouteChildren = {
  AccountSlugIndexRoute: AccountSlugIndexRoute,
  AccountSlugSubmissionIdSignerRoute: AccountSlugSubmissionIdSignerRoute,
  AccountSlugSubmissionIdIndexRoute: AccountSlugSubmissionIdIndexRoute,
  AccountSlugSubmissionIdAdditionalPersonalGuarantorsTokenTokenRoute:
    AccountSlugSubmissionIdAdditionalPersonalGuarantorsTokenTokenRoute,
  AccountSlugSubmissionIdAdditionalThirdPartiesTypeRoute:
    AccountSlugSubmissionIdAdditionalThirdPartiesTypeRoute,
  AccountSlugSubmissionIdAdditionalTradeReferencesTokenTokenRoute:
    AccountSlugSubmissionIdAdditionalTradeReferencesTokenTokenRoute,
  AccountSlugSubmissionIdSignerTokenTokenRoute:
    AccountSlugSubmissionIdSignerTokenTokenRoute,
  AccountSlugSubmissionIdTokenIndexRoute:
    AccountSlugSubmissionIdTokenIndexRoute,
}

const AccountSlugRouteRouteWithChildren =
  AccountSlugRouteRoute._addFileChildren(AccountSlugRouteRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$accountSlug': typeof AccountSlugRouteRouteWithChildren
  '/error': typeof ErrorRoute
  '/$accountSlug/': typeof AccountSlugIndexRoute
  '/$accountSlug/$submissionId/signer': typeof AccountSlugSubmissionIdSignerRoute
  '/$accountSlug/$submissionId': typeof AccountSlugSubmissionIdIndexRoute
  '/$accountSlug/$submissionId/additional-personal-guarantors-token/$token': typeof AccountSlugSubmissionIdAdditionalPersonalGuarantorsTokenTokenRoute
  '/$accountSlug/$submissionId/additional-third-parties/$type': typeof AccountSlugSubmissionIdAdditionalThirdPartiesTypeRoute
  '/$accountSlug/$submissionId/additional-trade-references-token/$token': typeof AccountSlugSubmissionIdAdditionalTradeReferencesTokenTokenRoute
  '/$accountSlug/$submissionId/signer-token/$token': typeof AccountSlugSubmissionIdSignerTokenTokenRoute
  '/$accountSlug/$submissionId/$token': typeof AccountSlugSubmissionIdTokenIndexRoute
  '/personal-guarantors/$accountSlug/$trackingId': typeof PersonalGuarantorsAccountSlugTrackingIdIndexRoute
  '/trade-references/$accountSlug/$trackingId': typeof TradeReferencesAccountSlugTrackingIdIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/error': typeof ErrorRoute
  '/$accountSlug': typeof AccountSlugIndexRoute
  '/$accountSlug/$submissionId/signer': typeof AccountSlugSubmissionIdSignerRoute
  '/$accountSlug/$submissionId': typeof AccountSlugSubmissionIdIndexRoute
  '/$accountSlug/$submissionId/additional-personal-guarantors-token/$token': typeof AccountSlugSubmissionIdAdditionalPersonalGuarantorsTokenTokenRoute
  '/$accountSlug/$submissionId/additional-third-parties/$type': typeof AccountSlugSubmissionIdAdditionalThirdPartiesTypeRoute
  '/$accountSlug/$submissionId/additional-trade-references-token/$token': typeof AccountSlugSubmissionIdAdditionalTradeReferencesTokenTokenRoute
  '/$accountSlug/$submissionId/signer-token/$token': typeof AccountSlugSubmissionIdSignerTokenTokenRoute
  '/$accountSlug/$submissionId/$token': typeof AccountSlugSubmissionIdTokenIndexRoute
  '/personal-guarantors/$accountSlug/$trackingId': typeof PersonalGuarantorsAccountSlugTrackingIdIndexRoute
  '/trade-references/$accountSlug/$trackingId': typeof TradeReferencesAccountSlugTrackingIdIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/$accountSlug': typeof AccountSlugRouteRouteWithChildren
  '/error': typeof ErrorRoute
  '/$accountSlug/': typeof AccountSlugIndexRoute
  '/$accountSlug/$submissionId/signer': typeof AccountSlugSubmissionIdSignerRoute
  '/$accountSlug/$submissionId/': typeof AccountSlugSubmissionIdIndexRoute
  '/$accountSlug/$submissionId/additional-personal-guarantors-token/$token': typeof AccountSlugSubmissionIdAdditionalPersonalGuarantorsTokenTokenRoute
  '/$accountSlug/$submissionId/additional-third-parties/$type': typeof AccountSlugSubmissionIdAdditionalThirdPartiesTypeRoute
  '/$accountSlug/$submissionId/additional-trade-references-token/$token': typeof AccountSlugSubmissionIdAdditionalTradeReferencesTokenTokenRoute
  '/$accountSlug/$submissionId/signer-token/$token': typeof AccountSlugSubmissionIdSignerTokenTokenRoute
  '/$accountSlug/$submissionId/$token/': typeof AccountSlugSubmissionIdTokenIndexRoute
  '/personal-guarantors/$accountSlug/$trackingId/': typeof PersonalGuarantorsAccountSlugTrackingIdIndexRoute
  '/trade-references/$accountSlug/$trackingId/': typeof TradeReferencesAccountSlugTrackingIdIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$accountSlug'
    | '/error'
    | '/$accountSlug/'
    | '/$accountSlug/$submissionId/signer'
    | '/$accountSlug/$submissionId'
    | '/$accountSlug/$submissionId/additional-personal-guarantors-token/$token'
    | '/$accountSlug/$submissionId/additional-third-parties/$type'
    | '/$accountSlug/$submissionId/additional-trade-references-token/$token'
    | '/$accountSlug/$submissionId/signer-token/$token'
    | '/$accountSlug/$submissionId/$token'
    | '/personal-guarantors/$accountSlug/$trackingId'
    | '/trade-references/$accountSlug/$trackingId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/error'
    | '/$accountSlug'
    | '/$accountSlug/$submissionId/signer'
    | '/$accountSlug/$submissionId'
    | '/$accountSlug/$submissionId/additional-personal-guarantors-token/$token'
    | '/$accountSlug/$submissionId/additional-third-parties/$type'
    | '/$accountSlug/$submissionId/additional-trade-references-token/$token'
    | '/$accountSlug/$submissionId/signer-token/$token'
    | '/$accountSlug/$submissionId/$token'
    | '/personal-guarantors/$accountSlug/$trackingId'
    | '/trade-references/$accountSlug/$trackingId'
  id:
    | '__root__'
    | '/'
    | '/$accountSlug'
    | '/error'
    | '/$accountSlug/'
    | '/$accountSlug/$submissionId/signer'
    | '/$accountSlug/$submissionId/'
    | '/$accountSlug/$submissionId/additional-personal-guarantors-token/$token'
    | '/$accountSlug/$submissionId/additional-third-parties/$type'
    | '/$accountSlug/$submissionId/additional-trade-references-token/$token'
    | '/$accountSlug/$submissionId/signer-token/$token'
    | '/$accountSlug/$submissionId/$token/'
    | '/personal-guarantors/$accountSlug/$trackingId/'
    | '/trade-references/$accountSlug/$trackingId/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountSlugRouteRoute: typeof AccountSlugRouteRouteWithChildren
  ErrorRoute: typeof ErrorRoute
  PersonalGuarantorsAccountSlugTrackingIdIndexRoute: typeof PersonalGuarantorsAccountSlugTrackingIdIndexRoute
  TradeReferencesAccountSlugTrackingIdIndexRoute: typeof TradeReferencesAccountSlugTrackingIdIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountSlugRouteRoute: AccountSlugRouteRouteWithChildren,
  ErrorRoute: ErrorRoute,
  PersonalGuarantorsAccountSlugTrackingIdIndexRoute:
    PersonalGuarantorsAccountSlugTrackingIdIndexRoute,
  TradeReferencesAccountSlugTrackingIdIndexRoute:
    TradeReferencesAccountSlugTrackingIdIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/$accountSlug",
        "/error",
        "/personal-guarantors/$accountSlug/$trackingId/",
        "/trade-references/$accountSlug/$trackingId/"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/$accountSlug": {
      "filePath": "$accountSlug/route.tsx",
      "children": [
        "/$accountSlug/",
        "/$accountSlug/$submissionId/signer",
        "/$accountSlug/$submissionId/",
        "/$accountSlug/$submissionId/additional-personal-guarantors-token/$token",
        "/$accountSlug/$submissionId/additional-third-parties/$type",
        "/$accountSlug/$submissionId/additional-trade-references-token/$token",
        "/$accountSlug/$submissionId/signer-token/$token",
        "/$accountSlug/$submissionId/$token/"
      ]
    },
    "/error": {
      "filePath": "error.tsx"
    },
    "/$accountSlug/": {
      "filePath": "$accountSlug/index.tsx",
      "parent": "/$accountSlug"
    },
    "/$accountSlug/$submissionId/signer": {
      "filePath": "$accountSlug/$submissionId/signer.tsx",
      "parent": "/$accountSlug"
    },
    "/$accountSlug/$submissionId/": {
      "filePath": "$accountSlug/$submissionId/index.tsx",
      "parent": "/$accountSlug"
    },
    "/$accountSlug/$submissionId/additional-personal-guarantors-token/$token": {
      "filePath": "$accountSlug/$submissionId/additional-personal-guarantors-token/$token.tsx",
      "parent": "/$accountSlug"
    },
    "/$accountSlug/$submissionId/additional-third-parties/$type": {
      "filePath": "$accountSlug/$submissionId/additional-third-parties/$type.tsx",
      "parent": "/$accountSlug"
    },
    "/$accountSlug/$submissionId/additional-trade-references-token/$token": {
      "filePath": "$accountSlug/$submissionId/additional-trade-references-token/$token.tsx",
      "parent": "/$accountSlug"
    },
    "/$accountSlug/$submissionId/signer-token/$token": {
      "filePath": "$accountSlug/$submissionId/signer-token/$token.tsx",
      "parent": "/$accountSlug"
    },
    "/$accountSlug/$submissionId/$token/": {
      "filePath": "$accountSlug/$submissionId/$token/index.tsx",
      "parent": "/$accountSlug"
    },
    "/personal-guarantors/$accountSlug/$trackingId/": {
      "filePath": "personal-guarantors/$accountSlug/$trackingId/index.tsx"
    },
    "/trade-references/$accountSlug/$trackingId/": {
      "filePath": "trade-references/$accountSlug/$trackingId/index.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
